import { Card, Col, Form, Input, Pagination, Row, Space, Table } from "antd";
import { useEffect, useState } from "react";
import FeatureToolbarComponent from "../sgvmap/widgets/feature/FeatureToolbarComponent";
import { EdrService } from "../../service/cartoService";
import ColumnGroup from "antd/es/table/ColumnGroup";
import Column from "antd/es/table/Column";


const VicaEDARSubvIAA = ({ results, mapView, table, mapLayer, sublayer, currentTabsResult, setCurrenTabsResult }) => {
    const [result, setResult] = useState(results[0]);
    const [current, setCurrent] = useState(1);

    const onChangePagination = (page) => {
        setCurrent(page);
        setResult(results[page - 1]);
        let copy = Object.assign({}, currentTabsResult);
        copy[mapLayer.name + ": " + sublayer.title] = results[page - 1];
        setCurrenTabsResult(copy);
    };

  

    return (
        <>
            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}
            <Row justify="end" style={{ paddingBottom: "10px", paddingTop: "5px" }}>
                <FeatureToolbarComponent mapView={mapView} table={table} mapLayer={mapLayer} sublayer={sublayer} feature={result.feature}></FeatureToolbarComponent>
            </Row>
            <div>
                <Content result={result}></Content>
            </div>

            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}

        </>
    )
};
export default VicaEDARSubvIAA;

const Content = ({ result }) => {

    const [edarEntidades, setEdarEntidades] = useState([]);

    const formatNumber = (num) => {
        if (num == null || num === undefined || num === "") {
            return "-";
        }
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    useEffect(() => {
        EdrService.listEdarEntidades(result.feature.attributes.ID_EDAR)
            .then((data) => {
                setEdarEntidades(data.lists);
            })
            .catch(err => {
                err.response.json().then(res => {
                    console.log("ERROR", res);
                });
            })
    }, [])

    //console.log("result", result)
    return (
        <Card>

            <Form
                layout="horizontal"
            >
                <Form.Item label="Año de subvención">
                    <Input value={result.feature.attributes.ID_ZONA/*result.feature.attributes.ANN_SUBVEN*/} />
                </Form.Item>
                <Form.Item label="Capacidad (hab.eq.)">
                    <Input value={formatNumber(result.feature.attributes.HAB_EQ_D)/*formatNumber(result.feature.attributes.HAB__EQ__DISEÑO_ADOPT)*/} />
                </Form.Item>
                <Form.Item label="Estado">
                    <Input value={result.feature.attributes.ESTADO} />
                </Form.Item>
                <Form.Item label="Parcela">
                    <Input value={result.feature.attributes.PARCELA} />
                </Form.Item>
                <Form.Item label="Coordenadas">
                    <Space.Compact>
                        <Form.Item>
                            <Input value={formatNumber(Math.round(result.feature.attributes.X))} />
                        </Form.Item>
                        <Form.Item>
                            <Input value={formatNumber(Math.round(result.feature.attributes.Y))} />
                        </Form.Item>
                    </Space.Compact>
                </Form.Item>
            </Form>
            {
                edarEntidades.length>0 && <Table dataSource={edarEntidades} pagination={false} >
                    <ColumnGroup title="Nucleos servidos">
                        <Column title="Municipio" dataIndex={["idMunicipio", "municipio"]} key="municipio" />
                        <Column title="Entidad" dataIndex="entidadSingular" key="entidadSingular" />
                        <Column title="Habitantes" dataIndex="hab" key="hab" />
                        <Column title="Observaciones" dataIndex="descripcion" key="descripcion" />
                    </ColumnGroup>
                </Table>
            }

        </Card>

    )
}